module.exports = __webpack_public_path__ + "static/pinkcardihamper-439a8b3c7a05590cda88ae7d26961ed5.jpeg";